module.exports = __webpack_public_path__ + "static/media/pull.9193fec8.jpg";